module.exports = __webpack_public_path__ + "img/pdf.1ec381cc.png";